var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessional05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2017 13.5C28.4443 13.5 29.4517 12.4926 29.4517 11.25C29.4517 10.0074 28.4443 9 27.2017 9C25.959 9 24.9517 10.0074 24.9517 11.25C24.9517 12.4926 25.959 13.5 27.2017 13.5Z",
    stroke: "#278DEC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2017 29.25C28.4443 29.25 29.4517 28.2426 29.4517 27C29.4517 25.7574 28.4443 24.75 27.2017 24.75C25.959 24.75 24.9517 25.7574 24.9517 27C24.9517 28.2426 25.959 29.25 27.2017 29.25Z",
    stroke: "#278DEC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2017 45C28.4443 45 29.4517 43.9926 29.4517 42.75C29.4517 41.5074 28.4443 40.5 27.2017 40.5C25.959 40.5 24.9517 41.5074 24.9517 42.75C24.9517 43.9926 25.959 45 27.2017 45Z",
    stroke: "#278DEC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9517 13.5C44.1943 13.5 45.2017 12.4926 45.2017 11.25C45.2017 10.0074 44.1943 9 42.9517 9C41.709 9 40.7017 10.0074 40.7017 11.25C40.7017 12.4926 41.709 13.5 42.9517 13.5Z",
    stroke: "#278DEC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9517 29.25C44.1943 29.25 45.2017 28.2426 45.2017 27C45.2017 25.7574 44.1943 24.75 42.9517 24.75C41.709 24.75 40.7017 25.7574 40.7017 27C40.7017 28.2426 41.709 29.25 42.9517 29.25Z",
    stroke: "#278DEC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9517 45C44.1943 45 45.2017 43.9926 45.2017 42.75C45.2017 41.5074 44.1943 40.5 42.9517 40.5C41.709 40.5 40.7017 41.5074 40.7017 42.75C40.7017 43.9926 41.709 45 42.9517 45Z",
    stroke: "#278DEC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4517 13.5C12.6943 13.5 13.7017 12.4926 13.7017 11.25C13.7017 10.0074 12.6943 9 11.4517 9C10.209 9 9.20166 10.0074 9.20166 11.25C9.20166 12.4926 10.209 13.5 11.4517 13.5Z",
    stroke: "#278DEC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4517 29.25C12.6943 29.25 13.7017 28.2426 13.7017 27C13.7017 25.7574 12.6943 24.75 11.4517 24.75C10.209 24.75 9.20166 25.7574 9.20166 27C9.20166 28.2426 10.209 29.25 11.4517 29.25Z",
    stroke: "#278DEC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4517 45C12.6943 45 13.7017 43.9926 13.7017 42.75C13.7017 41.5074 12.6943 40.5 11.4517 40.5C10.209 40.5 9.20166 41.5074 9.20166 42.75C9.20166 43.9926 10.209 45 11.4517 45Z",
    stroke: "#278DEC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessional05);
export default __webpack_public_path__ + "static/media/professional05.53320379e39494201bcb8d863a85d924.svg";
export { ForwardRef as ReactComponent };